import React, { useState } from "react";
import { FaRedo, FaCog, FaChevronDown, FaChevronUp } from "react-icons/fa";

interface DashboardControlsProps {
    onRefresh: () => void;
    onFilterSelect: (filter: string) => void;
    autoCycleEnabled: boolean;
    setAutoCycleEnabled: (enabled: boolean) => void;
    selectedPriceBasis: string;
    setSelectedPriceBasis: (basis: string) => void;
}

const priceBasisOptions = ["Invoiced", "Estimated", "Products", "Paid"];

const DashboardControls = ({
    onRefresh,
    onFilterSelect,
    autoCycleEnabled,
    setAutoCycleEnabled,
    selectedPriceBasis,
    setSelectedPriceBasis,
}: DashboardControlsProps) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [accordionOpen, setAccordionOpen] = useState(false);

    return (
        <div className="flex items-center space-x-4 mr-4 relative">
            {/* Refresh Button */}
            <button
                onClick={onRefresh}
                className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition"
                title="Refresh Data"
            >
                <FaRedo className="text-white" />
            </button>

            {/* Settings Dropdown */}
            <div className="relative">
                <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition"
                    title="Settings"
                >
                    <FaCog className="text-white" />
                </button>

                {dropdownOpen && (
                    <div className="absolute right-0 mt-2 bg-gray-800 text-white rounded shadow-lg w-48 z-50 p-2">

                        {/* Accordion - Price Basis */}
                        <button
                            className="w-full flex justify-between px-2 py-1 text-left hover:bg-gray-700 rounded"
                            onClick={() => setAccordionOpen(!accordionOpen)}
                        >
                            <span>Price Basis</span>
                            {accordionOpen ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                        {accordionOpen && (
                            <div className="mt-1 ml-2 space-y-1">
                                {priceBasisOptions.map((option) => (
                                    <button
                                        key={option}
                                        onClick={() => {
                                            setSelectedPriceBasis(option);
                                            onFilterSelect(option);
                                        }}
                                        className={`block w-full px-2 py-1 text-left rounded ${selectedPriceBasis === option
                                            ? "bg-[#1E90FF]"
                                            : "hover:bg-gray-700"
                                            }`}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        )}

                        {/* Auto-cycle toggle */}
                        <div className="mt-2 border-t border-gray-700 pt-2">
                            <label className="inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={autoCycleEnabled}
                                    onChange={() => setAutoCycleEnabled(!autoCycleEnabled)}
                                    className="ml-2 form-checkbox h-4 w-4 text-[#1E90FF] bg-gray-700 rounded border-gray-600"
                                />
                                <span className="ml-2 text-sm">Auto-cycle Divisions</span>
                            </label>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DashboardControls;
